import React from 'react'

import { Modal, Table, Button } from '_zari/core'

import TipoDocumentoSerieConstant from 'constants/tipoDocumentoSerie'

const tableHeaderRows = [{ label: 'TIPO DOC.' }, { label: 'SERIE', width: 80 }, { label: 'NUM. INICIAL', width: 120 }]

const TablaSeriesModal = ({ show, handleClose }) => {
  const rowTemplate = React.useCallback(
    row => (
      <Table.Row hover key={row._id}>
        <Table.Cell>{row.tipoSerie ? TipoDocumentoSerieConstant.__dictionary[row.tipoSerie].nombre : '--'}</Table.Cell>
        <Table.Cell>{row.serie}</Table.Cell>
        <Table.Cell>{row.numeroInicial}</Table.Cell>
      </Table.Row>
    ),
    []
  )

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>LISTA SERIES</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table.ServerSide
          useNest={true}
          url='/sedes/series'
          headRows={tableHeaderRows}
          rowTemplate={rowTemplate}
          rowsPerPage={5}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button tiny color='secondary' onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(TablaSeriesModal)
